import {supabase} from '../config/supabase'

// Enhanced function to map graphemes to phonemes
const mapGraphemesToPhonemes = (word, phonemeString) => {
  if (!word || !phonemeString) return { graphemes: [], phonemes: [] }

  // Clean and split phonemes - remove slashes and brackets
  const phonemes = phonemeString
    .replace(/[/[\]]/g, '') // Remove slashes and brackets
    .split(/[\s,]+/) // Split by spaces or commas
    .filter(p => p.trim()) // Remove empty entries
    .map(p => p.trim())

  const letters = word.toLowerCase().split('')
  const graphemes = []

  console.log('Mapping word:', word)
  console.log('Letters:', letters)
  console.log('Phonemes from DB:', phonemes)

  // CRITICAL FIX: Override incorrect database phonemes with TEACHER-FRIENDLY symbols
  const phonemeCorrections = {
    'and': ['ă', 'n', 'd'], 
    'because': ['b', 'ē', 'k', 'ŭ', 'z'], 
    'arrange': ['ŭ', 'r', 'ā', 'n', 'j'], 
    'change': ['ch', 'ā', 'n', 'j'], 
    'changes': ['ch', 'ā', 'n', 'j', 'ĕ', 'z'], // FIXED: Corrected mapping for changes
    'range': ['r', 'ā', 'n', 'j'], 
    'orange': ['or', 'ĭ', 'n', 'j'], 
    'strange': ['s', 't', 'r', 'ā', 'n', 'j'], 
    'capstone': ['k', 'ă', 'p', 's', 't', 'ō', 'n'],
    'plate': ['p', 'l', 'ā', 't'], 
    'excited': ['ĕ', 'k', 's', 'ī', 't', 'ĭ', 'd'],
    'coded': ['k', 'ō', 'd', 'ĭ', 'd'],
    'faded': ['f', 'ā', 'd', 'ĭ', 'd'],
    'know': ['n', 'ō'], 
    'knee': ['n', 'ē'], 
    'knife': ['n', 'ī', 'f'], 
    'knock': ['n', 'ŏ', 'k'], 
    'knot': ['n', 'ŏ', 't'], 
    'gnat': ['n', 'ă', 't'], 
    'gnome': ['n', 'ō', 'm'], 
    'ghost': ['g', 'ō', 's', 't'], 
    'wreck': ['r', 'ĕ', 'k'], 
    'write': ['r', 'ī', 't'], 
    'wrong': ['r', 'ŏ', 'ng'], 
    'psychic': ['s', 'ī', 'k', 'ĭ', 'k'], 
    'whistle': ['w', 'ĭ', 's', 'ŭ', 'l'], 
    'honest': ['ŏ', 'n', 'ĭ', 's', 't'], 
    'often': ['ŏ', 'f', 'ĕ', 'n'], 
    'castle': ['k', 'ă', 's', 'ŭ', 'l'], 
    'listen': ['l', 'ĭ', 's', 'ĕ', 'n'], 
    'hour': ['ou', 'r'], 
    'feign': ['f', 'ā', 'n'], 
    'ascend': ['ŭ', 's', 'ĕ', 'n', 'd'], 
    'balm': ['b', 'ä', 'm'], 
    'calm': ['k', 'ä', 'm'], 
    'palm': ['p', 'ä', 'm'], 
    'psalm': ['s', 'ä', 'm'], 
    'lamb': ['l', 'ă', 'm'], 
    'thumb': ['th', 'ŭ', 'm'], 
    'comb': ['k', 'ō', 'm'], 
    'tomb': ['t', 'ū', 'm'], 
    'doubt': ['d', 'ou', 't'], 
    'debt': ['d', 'ĕ', 't'], 
    'subtle': ['s', 'ŭ', 't', 'ŭ', 'l'], 
    'design': ['d', 'ĭ', 'z', 'ī', 'n'], 
    'resign': ['r', 'ĭ', 'z', 'ī', 'n'], 
    'sign': ['s', 'ī', 'n'], 
    'muscle': ['m', 'ŭ', 's', 'ŭ', 'l'], 
    'scene': ['s', 'ē', 'n'], 
    'scent': ['s', 'ĕ', 'n', 't'], 
    'science': ['s', 'ī', 'ĕ', 'n', 's'], 
    'island': ['ī', 'l', 'ă', 'n', 'd'], 
    'aisle': ['ī', 'l'], 
    'always': ['ô', 'l', 'w', 'ā', 'z'], 
    'allow': ['ŭ', 'l', 'ou'], 
    'alloy': ['ă', 'l', 'oi'], 
    'alimony': ['ă', 'l', 'ĭ', 'm', 'ō', 'n', 'ē'], 
    'ignite': ['ĭ', 'g', 'n', 'ī', 't'], 
    'cabal': ['k', 'ŭ', 'b', 'ä', 'l'], 
    'horror': ['h', 'orr', 'ŭ', 'r'], 
    'horrible': ['h', 'orr', 'ĭ', 'b', 'ŭ', 'l'], 
    'horrid': ['h', 'orr', 'ĭ', 'd'], 
    'reignite': ['r', 'ē', 'ĭ', 'g', 'n', 'ī', 't'], 
    'make': ['m', 'ā', 'k'], 
    'ignition': ['ĭ', 'g', 'n', 'ĭ', 'sh', 'ŭ', 'n'], 
    'confuse': ['k', 'ŭ', 'n', 'f', 'ū', 'z'], 
    'could': ['k', 'oo', 'd'], 
    'would': ['w', 'oo', 'd'], 
    'should': ['sh', 'oo', 'd'], 
    'apple': ['ă', 'p', 'ŭ', 'l'], 
    'supple': ['s', 'ŭ', 'p', 'ŭ', 'l'], 
    'cat': ['k', 'ă', 't'], 
    'dog': ['d', 'ŏ', 'g'], 
    'sun': ['s', 'ŭ', 'n'], 
    'tree': ['t', 'r', 'ē'], 
    'time': ['t', 'ī', 'm'], 
    'hope': ['h', 'ō', 'p'], 
    'cute': ['k', 'ū', 't'], 
    'bike': ['b', 'ī', 'k'], 
    'eight': ['ā', 't'], 
    'straight': ['s', 't', 'r', 'ā', 't'], 
    'coach': ['k', 'ō', 'ch'], 
    'weight': ['w', 'ā', 't'], 
    'freight': ['f', 'r', 'ā', 't'], 
    'neighbor': ['n', 'ā', 'b', 'ŭ', 'r'], 
    'sleigh': ['s', 'l', 'ā'], 
    'boat': ['b', 'ō', 't'], 
    'coat': ['k', 'ō', 't'], 
    'float': ['f', 'l', 'ō', 't'], 
    'goat': ['g', 'ō', 't'], 
    'road': ['r', 'ō', 'd'], 
    'soap': ['s', 'ō', 'p'], 
    'toad': ['t', 'ō', 'd'] 
  }

  const wordLower = word.toLowerCase()
  if (phonemeCorrections[wordLower]) {
    const correctPhonemes = phonemeCorrections[wordLower]
    const correctGraphemes = mapWordToGraphemes(word)
    return { graphemes: correctGraphemes, phonemes: correctPhonemes }
  }

  const convertToTeacherFriendly = (phonemeArray) => {
    return phonemeArray.map(phoneme => {
      const conversionMap = {
        'ə': 'ŭ', 'ɪ': 'ĭ', 'ɛ': 'ĕ', 'æ': 'ă', 'ʌ': 'ŭ', 'ʊ': 'oo', 'ɒ': 'ŏ', 'ɔ': 'ô',
        'iː': 'ē', 'i': 'ē', 'eɪ': 'ā', 'aɪ': 'ī', 'oʊ': 'ō', 'uː': 'ū', 'u': 'ū', 'ɔɪ': 'oi', 'aʊ': 'ou',
        'ɑr': 'ar', 'ɔr': 'or', 'ər': 'er', 'ɪr': 'ir', 'ʊr': 'ur',
        'ʤ': 'j', 'ʧ': 'ch', 'ʃ': 'sh', 'ʒ': 'zh', 'θ': 'th', 'ð': 'th', 'ŋ': 'ng', 'j': 'y', 'w': 'w',
        'b': 'b', 'p': 'p', 'd': 'd', 't': 't', 'g': 'g', 'k': 'k',
        'f': 'f', 'v': 'v', 's': 's', 'z': 'z', 'h': 'h', 'l': 'l',
        'm': 'm', 'n': 'n', 'r': 'r'
      }
      return conversionMap[phoneme] || phoneme
    })
  }

  const digraphs = ['ch', 'sh', 'th', 'wh', 'ph', 'ck', 'ng', 'qu', 'ay', 'ey', 'oy', 'ai', 'ee', 'oo', 'ou', 'ow', 'ea', 'ie', 'ue', 'ui', 'au', 'aw', 'er', 'ir', 'or', 'ur', 'kn', 'gn', 'wr', 'gh', 'ei', 'mb', 'bt', 'sc', 'oa']
  const trigraphs = ['tch', 'dge', 'igh', 'air', 'ear', 'our', 'orr']
  const quadrigraphs = ['eigh', 'augh']
  const doubleLetters = ['ss', 'ff', 'll', 'zz', 'tt', 'dd', 'bb', 'cc', 'gg', 'mm', 'nn', 'pp', 'rr']
  const silentConsonantPatterns = ['kn', 'gn', 'wr', 'mn', 'bt', 'mb', 'sc']
  
  let i = 0
  let phonemeIndex = 0

  while (i < letters.length && phonemeIndex < phonemes.length) {
    let matched = false

    if (!matched && i <= letters.length - 4) {
      const fourLetters = letters.slice(i, i + 4).join('')
      if (quadrigraphs.includes(fourLetters)) {
        graphemes.push(fourLetters); i += 4; phonemeIndex++; matched = true
      }
    }

    if (!matched && i <= letters.length - 3) {
      const threeLetters = letters.slice(i, i + 3).join('')
      if (threeLetters === 'orr' && ['horror', 'horrible', 'horrid'].includes(wordLower)) {
        graphemes.push('orr'); i += 3; phonemeIndex++; matched = true
      }
    }

    if (!matched && i === 0 && i <= letters.length - 2) {
      const twoLetters = letters.slice(i, i + 2).join('')
      if (silentConsonantPatterns.includes(twoLetters)) {
        graphemes.push(twoLetters); i += 2; phonemeIndex++; matched = true
      }
    }

    if (!matched && i <= letters.length - 2) {
      const digraph = letters.slice(i, i + 2).join('')
      if (digraphs.includes(digraph)) {
        graphemes.push(digraph); i += 2; phonemeIndex++; matched = true
      }
    }

    if (!matched) {
      graphemes.push(letters[i]); i++; phonemeIndex++
    }
  }

  while (i < letters.length) {
    graphemes.push(letters[i]); i++
  }

  const cleanGraphemes = graphemes.filter(g => g && g.trim())
  const teacherFriendlyPhonemes = convertToTeacherFriendly(phonemes)

  while (cleanGraphemes.length > teacherFriendlyPhonemes.length && teacherFriendlyPhonemes.length > 0) {
    const last = cleanGraphemes.pop()
    cleanGraphemes[cleanGraphemes.length - 1] += last
  }

  return { graphemes: cleanGraphemes, phonemes: teacherFriendlyPhonemes }
}

const mapWordToGraphemes = (word) => {
  const wordLower = word.toLowerCase()
  const graphemeMap = {
    'and': ['a', 'n', 'd'],
    'because': ['b', 'e', 'c', 'au', 'se'],
    'arrange': ['a', 'rr', 'a', 'n', 'ge'],
    'change': ['ch', 'a', 'n', 'ge'],
    'changes': ['ch', 'a', 'n', 'g', 'e', 's'], // FIXED: Corrected graphemes for changes
    'range': ['r', 'a', 'n', 'ge'],
    'orange': ['o', 'r', 'a', 'n', 'ge'],
    'strange': ['s', 't', 'r', 'a', 'n', 'ge'],
    'capstone': ['c', 'a', 'p', 's', 't', 'o', 'n', 'e'],
    'plate': ['p', 'l', 'a', 'te'],
    'excited': ['e', 'x', 'c', 'i', 't', 'e', 'd'],
    'coded': ['c', 'o', 'd', 'e', 'd'],
    'faded': ['f', 'a', 'd', 'e', 'd'],
    'know': ['kn', 'ow'],
    'knee': ['kn', 'ee'],
    'knife': ['kn', 'i', 'fe'],
    'knock': ['kn', 'o', 'ck'],
    'knot': ['kn', 'o', 't'],
    'gnat': ['gn', 'at'],
    'gnome': ['gn', 'o', 'me'],
    'ghost': ['gh', 'o', 's', 't'],
    'wreck': ['wr', 'e', 'ck'],
    'write': ['wr', 'i', 'te'],
    'wrong': ['wr', 'o', 'ng'],
    'psychic': ['ps', 'y', 'ch', 'i', 'c'],
    'whistle': ['wh', 'i', 'st', 'le'],
    'honest': ['ho', 'n', 'e', 's', 't'],
    'often': ['o', 'ft', 'e', 'n'],
    'castle': ['c', 'a', 'st', 'le'],
    'listen': ['l', 'i', 'st', 'e', 'n'],
    'hour': ['h', 'ou', 'r'],
    'feign': ['f', 'ei', 'gn'],
    'ascend': ['a', 'sc', 'e', 'n', 'd'],
    'balm': ['b', 'al', 'm'],
    'calm': ['c', 'al', 'm'],
    'palm': ['p', 'al', 'm'],
    'psalm': ['ps', 'al', 'm'],
    'lamb': ['l', 'a', 'mb'],
    'thumb': ['th', 'u', 'mb'],
    'comb': ['c', 'o', 'mb'],
    'tomb': ['t', 'o', 'mb'],
    'doubt': ['d', 'ou', 'bt'],
    'debt': ['d', 'e', 'bt'],
    'subtle': ['s', 'u', 'bt', 'le'],
    'design': ['d', 'e', 's', 'i', 'gn'],
    'resign': ['r', 'e', 's', 'i', 'gn'],
    'sign': ['s', 'i', 'gn'],
    'muscle': ['m', 'u', 'sc', 'le'],
    'scene': ['sc', 'e', 'ne'],
    'scent': ['sc', 'e', 'n', 't'],
    'science': ['sc', 'i', 'e', 'n', 'ce'],
    'island': ['i', 's', 'l', 'a', 'n', 'd'],
    'aisle': ['ai', 's', 'le'],
    'always': ['a', 'l', 'w', 'ay', 's'],
    'allow': ['a', 'll', 'ow'],
    'alloy': ['a', 'll', 'oy'],
    'alimony': ['a', 'l', 'i', 'm', 'o', 'n', 'y'],
    'ignite': ['i', 'g', 'n', 'i', 'te'],
    'cabal': ['c', 'a', 'b', 'a', 'l'],
    'horror': ['h', 'orr', 'or'],
    'horrible': ['h', 'orr', 'i', 'b', 'le'],
    'horrid': ['h', 'orr', 'i', 'd'],
    'reignite': ['r', 'e', 'i', 'g', 'n', 'i', 'te'],
    'make': ['m', 'a', 'ke'],
    'ignition': ['i', 'g', 'n', 'i', 'ti', 'o', 'n'],
    'confuse': ['c', 'o', 'n', 'f', 'u', 'se'],
    'could': ['c', 'oul', 'd'],
    'would': ['w', 'oul', 'd'],
    'should': ['sh', 'oul', 'd'],
    'apple': ['a', 'pp', 'le'],
    'supple': ['s', 'u', 'pp', 'le'],
    'eight': ['eigh', 't'],
    'straight': ['s', 't', 'r', 'aigh', 't'],
    'coach': ['c', 'oa', 'ch'],
    'weight': ['w', 'eigh', 't'],
    'freight': ['f', 'r', 'eigh', 't'],
    'neighbor': ['n', 'eigh', 'b', 'o', 'r'],
    'sleigh': ['s', 'l', 'eigh'],
    'boat': ['b', 'oa', 't'],
    'coat': ['c', 'oa', 't'],
    'float': ['f', 'l', 'oa', 't'],
    'goat': ['g', 'oa', 't'],
    'road': ['r', 'oa', 'd'],
    'soap': ['s', 'oa', 'p'],
    'toad': ['t', 'oa', 'd']
  }
  return graphemeMap[wordLower] || word.split('')
}

export const testConnection = async () => {
  try {
    const { data, error } = await supabase.from('Word List').select('Word, Phonemes').limit(1)
    if (error) return { success: false, error: error.message }
    return { success: true, data }
  } catch (err) {
    return { success: false, error: err.message }
  }
}

export const searchWord = async (word) => {
  try {
    const searchTerm = word.trim()
    const searchVariations = [searchTerm.toLowerCase(), searchTerm.charAt(0).toUpperCase() + searchTerm.slice(1).toLowerCase(), searchTerm.toUpperCase(), searchTerm]
    let result = null
    for (const variation of searchVariations) {
      const { data, error } = await supabase.from('Word List').select('Word, Phonemes').eq('Word', variation).maybeSingle()
      if (data) { result = data; break }
    }
    if (!result) {
      const { data } = await supabase.from('Word List').select('Word, Phonemes').ilike('Word', searchTerm).limit(1).maybeSingle()
      result = data
    }
    if (result) {
      const { graphemes, phonemes } = mapGraphemesToPhonemes(result.Word || searchTerm, result.Phonemes)
      return { word: result.Word, phonemes: phonemes, graphemes: graphemes }
    }
    return null
  } catch (error) {
    console.error('Error searching word:', error);
    throw error;
  }
}